import comp from "./AITutorSegmentControl";
export default comp;
